import { useNavigate } from 'react-router-dom';

import { Layout } from '../components/Layout';
import { RegisterForm } from '../components/RegisterForm';
import { useEffect } from 'react';
import storage from '@/utils/storage';
import { logoutUser } from '../api/logout.api';
import { queryClient } from '@/lib/react-query';

export const Register = () => {
  const navigate = useNavigate();

  const logout = async () => {
    await logoutUser();
    queryClient.clear();
    localStorage.clear();
  };

  useEffect(() => {
    if (storage.getToken() !== undefined && storage.getToken() !== null) {
      logout();
    }
  }, []);

  return (
    <Layout title="Sign Up">
      <RegisterForm onSuccess={() => navigate('/auth/login')} />
    </Layout>
  );
};
